<template>
  <div class="form">
    <div class="form__content">
      <h1 class="extra-large-headline">Purpose of transaction.</h1>
      <p class="bodycopy">
        Before we process your order, we’re legally obligated to collect the
        additional information below.
      </p>
    </div>
    <form @submit.prevent>
      <FormSelect
        name="potMainPurpose"
        label="What is the main purpose that you are trading cryptocurrencies?"
        type="text"
        iconType="QuestionMarkCircle"
        iconColor="#0072CA"
        :items="potMainPurposeAnswers"
        @dropdownValueUpdate="updateDropdown"
      />

      <Checkbox
        name="tnc"
        text="I confirm that all funds used to trade originate from legal activities."
        v-model:value="form.tnc"
        v-model:tnc="form.tnc"
        :errors="store.getErrorByField('tnc')"
      />

      <ButtonBase
        :isDisabled="store.formHasErrors || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        Submit my details
      </ButtonBase>
    </form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { usePurposeOfTransactionStoreStore } from "@/stores/forms/purposeOfTransactionFormStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useApiHelpers from "@/composables/api/helpers";
import useWatchAndUpdate from "@/composables/helpers/useWatchAndUpdate";
import useCustomerActions from "@/composables/api/useCustomerActions";

import FormSelect from "@/components/ui/selects/FormSelect.vue";
import Checkbox from "@/components/ui/inputs/Checkbox.vue";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";

const router = useRouter();
const store = usePurposeOfTransactionStoreStore();
const identityQueueStore = useIdentityQueueStore();
const globalStore = useGlobalStore();
const { postRequest } = useApiHelpers();
const { watchAndUpdateStore } = useWatchAndUpdate();
const { fetchCustomerId } = useCustomerActions();

// todo mocked for now, to get from an endpoint
const potMainPurposeAnswers = [
  "Investment",
  "Trading",
  "Payment for online purchases",
  "Payment for services",
  "Gaming",
  "Ransomware / virus/ cyber extortion demands",
  "Other",
];

const form = ref({
  potMainPurpose: "",
  tnc: false,
});

const updateDropdown = (dropdownData) => {
  const field = Object.keys(dropdownData)[0];
  const value = Object.values(dropdownData)[0];
  form.value[field] = value;
};

const handleFormSubmit = async () => {
  const custId = await fetchCustomerId();

  const formData = {
    documentType: "purpose_of_transaction",
    documentReference: custId,
    declaredPurposeOfTransaction: [form.value.potMainPurpose],
  };

  globalStore.setIsFormLoading(true);
  postRequest("documents/edd", formData, () =>
    router.push(identityQueueStore.getNextIdentityRoute)
  );
};

watchAndUpdateStore(form, store, () => {});
</script>
